module.exports = {
  chargePartTypeKG: 'Divided by weight (KG)',
  chargePartTypeCBM: 'Billing by Volume (CBM)',
  chargePartTypeTipsL1: 'tips: What is the billing range type?',
  chargePartTypeTipsL2: 'Dividing by weight (KG) means that the weight of the goods is different, and the freight price is different.',
  chargePartTypeTipsL3: 'Dividing by volume (CBM) means that the volume of the goods is different, and the freight price is different.'
}
